import { render, staticRenderFns } from "./CaseOverviewOtherHolders.vue?vue&type=template&id=6581c283"
import script from "./CaseOverviewOtherHolders.vue?vue&type=script&lang=js"
export * from "./CaseOverviewOtherHolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports